import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  height: (p) => p.spacing(55.25),
  width: '100%',
  background: (p) => p.palette.common.white,
  padding: (p) => p.spacing(3),
  borderWidth: '2px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.primary[500],
  borderRadius: (p) => p.spacing(1),
  boxSizing: 'border-box',
  justifyContent: 'space-between',
};

export const title: SxStyle = {
  fontSize: '18px',
  fontWeight: 700,
  background: `linear-gradient(to right, #000000 50%, #666666 100%)`,
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  color: 'transparent',
};

export const planBox: SxStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: 0.5,
  width: 90,
  backgroundColor: (p) => p.palette.primary[50],
  borderRadius: 2,
};

export const icon: SxStyle = {
  color: (x) => x.palette.grey[400],
  marginInlineStart: 0.5,
};

export const button: SxStyle = {
  width: '100%',
  mt: 2,
};
